<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header" v-if="isIndex()">
        <div style="text-align: start">
          <el-button
            class="btn btn-success custom-shadow-btn"
            @click="dialogVisibleFilters = true"
          >
            {{ $t('common_words.filters') }}
          </el-button>
        </div>
        <card class="custom-shadow-card-header mt-2">
          <FullCalendar ref="fullCalendar" :options="calendarOptions" />
        </card>
        <el-dialog
          :title="`${$t('common_words.filters')}`"
          :visible.sync="dialogVisibleFilters"
          width="60%"
        >
          <el-form
            :label-position="'top'"
            :model="filter"
            :rules="rulesFilter"
            ref="filter"
          >
            <el-row :gutter="20">
              <el-col :md="5">
                <el-form-item :label="`${$t('common_words.year')}`" prop="year">
                  <el-date-picker
                    type="year"
                    class="shadow-sm required-year"
                    v-model="filter.year"
                    value-format="yyyy"
                    :picker-options="pickerOptions"
                    :placeholder="`${$t('common_words.select2')}...`"
                /></el-form-item>
              </el-col>
              <el-col :md="10">
                <el-form-item
                  :label="`${$t('grow.responsibles')}`"
                  prop="responsibleIds"
                >
                  <el-select
                    multiple
                    collapse-tags
                    clearable
                    filterable
                    class="select-primary custom-width-select shadow-sm"
                    v-model="filter.responsibleIds"
                    :placeholder="`${$t('common_words.select')}...`"
                    @change="
                      selectAllFromSelect('filter.responsibleIds', listUsers)
                    "
                  >
                    <el-option
                      v-for="(user, key) in this.concatAll(
                        listUsers,
                        null,
                        $t('uti.mixinMasters.selectAll2')
                      )"
                      class="select-primary selected-all"
                      :key="key"
                      :label="user.name"
                      :value="user.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!--<el-col :md="7">
                <el-form-item
                  :label="`${$t('common_words.area2')}`"
                  prop="areaIds"
                >
                  <el-select
                    multiple
                    collapse-tags
                    clearable
                    filterable
                    class="select-primary custom-width-select shadow-sm"
                    v-model="filter.areaIds"
                    :placeholder="`${$t('common_words.select')}...`"
                    @change="selectAllFromSelect('filter.areaIds', listAreas)"
                  >
                    <el-option
                      v-for="area in this.concatAll(
                        listAreas,
                        null,
                        $t('uti.mixinMasters.selectAll2')
                      )"
                      class="select-primary selected-all"
                      :value="area.id"
                      :label="area.name"
                      :key="area.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item> </el-col
            >-->
              <el-col :md="9">
                <el-form-item
                  :label="`${$t('common_words.companies')}`"
                  prop="businessesIds"
                >
                  <el-select
                    multiple
                    collapse-tags
                    clearable
                    filterable
                    class="select-primary custom-width-select shadow-sm"
                    v-model="filter.businessesIds"
                    :placeholder="`${$t('common_words.select')}...`"
                    @change="
                      selectAllFromSelect(
                        'filter.businessesIds',
                        listBusinesses
                      )
                    "
                  >
                    <el-option
                      v-for="(business, key) in this.concatAll(
                        listBusinesses,
                        null,
                        $t('uti.mixinMasters.selectAll2')
                      )"
                      class="select-primary selected-all"
                      :key="key"
                      :label="business.name"
                      :value="business.id"
                    ></el-option>
                  </el-select>
                </el-form-item> </el-col
            ></el-row>
            <el-row :gutter="20">
              <!--<el-col :md="12">
                <el-form-item
                  :label="`${$t('common_words.farms')}`"
                  prop="farmIds"
                >
                  <el-select
                    multiple
                    collapse-tags
                    clearable
                    filterable
                    class="select-primary custom-width-select shadow-sm"
                    v-model="filter.farmIds"
                    :placeholder="`${$t('common_words.select')}...`"
                    @change="
                      selectAllFromSelect('filter.farmIds', filteredFarms)
                    "
                  >
                    <el-option
                      v-for="(farm, key) in this.concatAll(
                        filteredFarms,
                        null,
                        $t('uti.mixinMasters.selectAll2')
                      )"
                      class="select-primary selected-all"
                      :key="key"
                      :label="farm.name"
                      :value="farm.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>-->
            </el-row>
            <el-row :gutter="20" class="text-center">
              <el-button
                class="btn btn-success custom-shadow-btn"
                @click="consultData('filter')"
                >{{ $t('common_words.filter') }}</el-button
              >
            </el-row>
          </el-form>
        </el-dialog>
        <el-dialog
          :title="`${$t('grow.activitylog')}`"
          :visible.sync="dialogVisible"
          width="90%"
          :before-close="handleClose"
        >
          <el-form
            :label-position="'top'"
            :model="model"
            :rules="rulesModel"
            ref="form"
          >
            <el-row :gutter="20">
              <el-col :md="7">
                <el-form-item :label="`${$t('common_words.date')}`" prop="date">
                  <el-date-picker
                    v-model="model.date"
                    class="shadow-sm"
                    type="date"
                    value-format="yyyy-MM-dd"
                    size="large"
                    :placeholder="`${$t('common_words.select2')}...`"
                    :picker-options="pickerOptionsDate"
                    :disabled="isDisabled"
                    :clearable="false"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :md="9">
                <el-form-item
                  :label="`${$t('grow.responsible')}`"
                  prop="responsibleId"
                >
                  <el-select
                    filterable
                    v-model="model.responsibleId"
                    :placeholder="`${$t('common_words.select')}...`"
                    class="select-primary custom-width-select shadow-sm"
                    size="large"
                    :disabled="isDisabled"
                  >
                    <el-option
                      v-for="(user, key) in listUsers"
                      :key="key"
                      :label="user.name"
                      :value="user.id"
                      class="select-primary"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="8">
                <el-form-item
                  :label="`${$t('common_words.email')}`"
                  prop="email"
                >
                  <el-input
                    v-model="model.email"
                    placeholder="xxxx@gmail.com"
                    class="shadow-sm"
                    :disabled="isDisabled"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :md="12">
                <el-form-item
                  :label="`${$t('common_words.company')}`"
                  prop="businessId"
                >
                  <el-select
                    filterable
                    v-model="model.businessId"
                    :placeholder="`${$t('common_words.select')}...`"
                    class="select-primary custom-width-select shadow-sm"
                    size="large"
                    :disabled="isDisabled"
                  >
                    <el-option
                      v-for="(business, key) in listBusinesses"
                      :key="key"
                      :label="business.name"
                      :value="business.id"
                      class="select-primary"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!--<el-col :md="8">
                <el-form-item
                  :label="`${$t('common_words.farm')}`"
                  prop="farmId"
                >
                  <el-select
                    filterable
                    v-model="model.farmId"
                    :placeholder="`${$t('common_words.select')}...`"
                    class="select-primary custom-width-select shadow-sm"
                    size="large"
                    :disabled="isDisabled"
                  >
                    <el-option
                      v-for="(farm, key) in filteredFarmsTwo"
                      :key="key"
                      :label="farm.name"
                      :value="farm.id"
                      class="select-primary"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>-->
              <el-col :md="6">
                <el-form-item
                  :label="`${$t('common_words.area')}`"
                  prop="areaId"
                >
                  <el-select
                    filterable
                    v-model="model.areaId"
                    :placeholder="`${$t('common_words.select')}...`"
                    class="select-primary custom-width-select shadow-sm"
                    size="large"
                    :disabled="isDisabled"
                  >
                    <el-option
                      v-for="(area, key) in listAreas"
                      :key="key"
                      :label="area.name"
                      :value="area.id"
                      class="select-primary"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="6">
                <el-form-item :label="`${$t('common_words.status')}`">
                  <el-input
                    v-model="model.status"
                    class="shadow-sm statusOptexpired"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :md="8">
                <el-form-item
                  :label="`${$t('grow.planned_activities')}`"
                  prop="totalAssigned"
                >
                  <el-input
                    v-model="model.totalAssigned"
                    :placeholder="`${$t('grow.planned_activities')}`"
                    class="shadow-sm"
                    disabled
                  ></el-input> </el-form-item
              ></el-col>
              <el-col :md="8">
                <el-form-item
                  :label="`${$t('grow.activities_completed')}`"
                  prop="totalCompleted"
                >
                  <el-input
                    v-model="model.totalCompleted"
                    :placeholder="`${$t('grow.activities_completed')}`"
                    class="shadow-sm"
                    disabled
                  ></el-input> </el-form-item
              ></el-col>
              <el-col :md="8">
                <el-form-item
                  :label="`${$t('grow.percentage_compliance')} (%)`"
                  prop="compliancePercentage"
                >
                  <el-input
                    v-model="model.compliancePercentage"
                    :placeholder="`${$t('grow.percentage_compliance')}`"
                    class="shadow-sm"
                    disabled
                  ></el-input> </el-form-item
              ></el-col>
            </el-row>
            <el-row
              :gutter="20"
              class="text-center"
              v-if="model.listActivities.length > 0"
            >
              <el-col :md="24">
                <el-button
                  class="btn btn-fg btn-add custom-shadow-btn"
                  @click="showTable = !showTable"
                  ><span v-if="!showTable">
                    {{ $t('common_words.view') }}
                  </span>
                  <span v-else>
                    {{ $t('common_words.hide') }}
                  </span>
                  {{ $t('grow.activitylog') }}
                </el-button>
                <el-button
                  @click="handleRemove(model.id)"
                  class="btn btn-danger custom-shadow-btn"
                  ><span>
                    {{ $t('common_words.delete') }} {{ $t('grow.activitylog') }}
                  </span>
                </el-button>
              </el-col>
            </el-row>
            <el-row :gutter="20" class="mt-2" v-if="showTable">
              <el-col :md="24">
                <card-header
                  :propPagination="pagination"
                  @searchedQuery="searchedQuery"
                  class="mr-3 mt-1"
                ></card-header>
                <el-table
                  stripe
                  :default-sort="{ prop: 'percentage', order: 'descending' }"
                  :data="queriedData"
                  max-height="500"
                  style="width: 100%"
                  :border="true"
                >
                  <el-table-column
                    v-for="column in tableColumns"
                    :key="column.label"
                    :min-width="column.minWidth"
                    :prop="column.prop"
                    :label="column.label"
                    :fixed="column.fixed"
                    :sortable="column.sortable"
                    :align="column.align"
                    :resizable="false"
                  >
                    <template slot-scope="props">
                      <span
                        v-if="column.prop == 'compliance'"
                        :style="{
                          color:
                            props.row.compliance_score == 0 ? 'red' : 'green',
                          fontWeight: 'bold',
                        }"
                      >
                        {{ props.row[column.prop] }}
                      </span>

                      <span v-else-if="column.prop == 'option'">
                        <a
                          v-if="
                            isUpdate() &&
                            rowIndex !== props.$index &&
                            rowIndex == -1 &&
                            isEditableDate(model.date)
                          "
                          v-tooltip.top-center="$t('common_words.edit')"
                          class="btn-warning btn-simple btn-link custom-margin-actions"
                          @click="startEditing(props.row, props.$index)"
                        >
                          <em class="fa fa-edit custom-size-fa-actions"></em>
                        </a>

                        <a
                          v-else-if="
                            (isUpdate() &&
                              rowIndex !== props.$index &&
                              rowIndex !== -1) ||
                            !isEditableDate(model.date)
                          "
                          class="btn-primary btn-simple btn-link custom-margin-actions"
                          style="cursor: not-allowed; opacity: 0.5"
                        >
                          <em class="fa fa-edit custom-size-fa-actions"></em>
                        </a>

                        <a
                          v-if="isUpdate() && rowIndex === props.$index"
                          v-tooltip.top-center="$t('common_words.save')"
                          class="btn-success btn-simple btn-link custom-margin-actions"
                          @click="saveRow(props.row, model, props.$index)"
                        >
                          <em class="fa fa-save custom-size-fa-actions"></em>
                        </a>
                        <a
                          v-if="isUpdate() && rowIndex === props.$index"
                          v-tooltip.top-center="$t('common_words.cancel')"
                          class="btn-danger btn-simple btn-link custom-margin-actions"
                          @click="cancelEditing(props.row)"
                        >
                          <em class="fa fa-times custom-size-fa-actions"></em>
                        </a>
                      </span>

                      <span v-else>
                        <span
                          v-if="
                            column.prop == 'answer' && rowIndex === props.$index
                          "
                        >
                          <el-input
                            v-if="
                              ['Texto', 'Numérica'].includes(
                                props.row.calification_type
                              )
                            "
                            :type="
                              props.row.calification_type == 'Texto'
                                ? 'text'
                                : 'number'
                            "
                            v-model="props.row.answer"
                            class="shadow-sm"
                            :placeholder="props.row.activity"
                          />

                          <el-select
                            v-else
                            filterable
                            :clearable="true"
                            class="select-primary custom-width-select shadow-sm"
                            size="large"
                            v-model="props.row.selected_option_id"
                            :placeholder="`${$t('common_words.select')}...`"
                            @change="updateAnswerText(props.row)"
                          >
                            <el-option
                              v-for="opt in props.row.options"
                              class="select-primary"
                              :key="opt.id"
                              :label="opt.name"
                              :value="opt.id"
                            ></el-option>
                          </el-select>
                        </span>

                        <span v-else>
                          {{ props.row[column.prop] }}
                        </span>
                      </span>
                    </template></el-table-column
                  ></el-table
                ></el-col
              ></el-row
            ></el-form
          ></el-dialog
        ></card
      >
    </div>
  </div>
</template>
<script>
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import { Axios } from 'src/class/Axios.js';
import SweetAlert from 'src/class/Alerts';
import moment from 'moment';
import i18n from 'src/i18n';
import { EventBus } from '../../../../../../util/bus';
import MixinCharts from 'src/util/mixinCharts';

import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import allLocales from '@fullcalendar/core/locales-all';
import multiMonthPlugin from '@fullcalendar/multimonth';
import Card from '../../../../../../components/Cards/Card.vue';

import { Pagination as LPagination } from 'src/components/index';
import Fuse from 'fuse.js';
import configTable from './ActivityLogTable';

export default {
  mixins: [MixinPermissions, mixinMasters, MixinMenu, MixinCharts],
  components: {
    FullCalendar,
    Card,
    LPagination,
  },
  data() {
    return {
      calendarOptions: {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          multiMonthPlugin,
        ],
        eventContent: function (arg) {
          return {
            html: arg.event.title,
          };
        },
        locales: allLocales,
        locale: 'es',
        headerToolbar: {
          left: 'prev next today',
          center: 'title',
          right: 'multiMonthYear dayGridMonth timeGridWeek timeGridDay',
        },
        buttonText: {
          today: this.$t('common_words.today'),
          month: this.$t('common_words.month'),
          week: this.$t('common_words.week'),
          day: this.$t('common_words.day'),
          multiMonthYear: this.$t('common_words.year'),
        },
        customButtons: {
          myFilterButton: {
            text: `${this.$t('common_words.filters')}`,
            click: () => {
              this.dialogVisibleFilters = true;
            },
          },
        },
        weekends: true,
        editable: false,
        displayEventTime: false,
        selectable: false,
        dayMaxEvents: 1,
        eventDisplay: 'block',
        initialView: 'dayGridMonth',
        eventClick: this.handleEventClick,
        events: [],
        aspectRatio: 2.4,
      },

      /* Filtros */
      filter: {
        year: moment().format('YYYY'),
        responsibleIds: [],
        //areaIds: [],
        businessesIds: [],
        //farmIds: [],
      },
      listAreas: [],
      listUsers: [],
      listBusinesses: [],
      //listFarms: [],
      dialogVisibleFilters: false,
      rulesFilter: {
        year: {
          required: true,
          message: this.$i18n.t('common_words.required_field'),
          trigger: 'blur',
        },
        responsibleIds: [
          {
            required: true,
            message: this.$i18n.t('common_words.required_field'),
            trigger: 'blur',
          },
        ],
        /*areaIds: [
          {
            required: true,
            message: this.$t('common_words.required_field'),
            trigger: 'change',
          },
        ],*/
        businessesIds: [
          {
            required: true,
            message: this.$i18n.t('common_words.required_field'),
            trigger: 'blur',
          },
        ],
        /*farmIds: [
          {
            required: true,
            message: this.$i18n.t('common_words.required_field'),
            trigger: 'blur',
          },
        ],*/
      },
      pickerOptions: {
        disabledDate(time) {
          const currentYear = new Date().getFullYear();
          const selectedYear = new Date(time).getFullYear();
          return selectedYear > currentYear;
        },
      },

      /* Eventos */
      dialogVisible: false,
      isDisabled: true,
      ShowEditButton: false,
      listEvents: [],
      model: {
        id: null,
        responsibleId: null,
        email: null,
        date: null,
        year: null,
        businessId: null,
        //farmId: null,
        areaId: null,
        statusId: null,
        status: null,
        totalAssigned: null,
        totalCompleted: null,
        compliancePercentage: null,
        listActivities: [],
        registered_audit_ID: null,
        auditId: null,
      },
      rulesModel: {},
      pickerOptionsDate: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() < today.getTime();
        },
      },

      rowIndex: -1,
      originalRowData: null,

      /* Tabla */
      showTable: false,
      Table: {},
      Search: {},
      pagination: {},
      tableColumns: [],
      tableData: [],
      searchQuery: '',
      fuseSearch: null,
    };
  },

  computed: {
    /*filteredFarms() {
      if (this.filter.businessesIds.length === 0) {
        return [];
      }
      const selectedBusinesses = this.listBusinesses.filter((business) => {
        return this.filter.businessesIds.includes(business.id);
      });
      const extractedFarms = selectedBusinesses.flatMap(
        (business) => business.farms || []
      );
      const uniqueFarms = Array.from(
        new Map(extractedFarms.map((item) => [item.id, item])).values()
      );
      const sortedFarms = uniqueFarms.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
      return sortedFarms;
    },

    filteredFarmsTwo() {
      if (!this.model.businessId) {
        return [];
      }
      const selectedBusiness = this.listBusinesses.find((business) => {
        return business.id === this.model.businessId;
      });
      const extractedFarms =
        selectedBusiness && selectedBusiness.farms
          ? selectedBusiness.farms
          : [];
      const sortedFarms = [...extractedFarms].sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
      return sortedFarms;
    },*/

    ...configTable().Search,
  },

  /*watch: {
    'filter.businessesIds': {
      handler() {
        if (this.filter.farmIds.length > 0) {
          this.filter.farmIds = this.filter.farmIds.filter((selectedFarmId) => {
            return this.filteredFarms.some(
              (farm) => farm.id === selectedFarmId
            );
          });
        }
      },
      deep: true,
    },

    'model.businessId': {
      handler() {
        if (this.model.farmId) {
          const existeFincaEnEmpresaNueva = this.filteredFarms.some(
            (farm) => farm.id === this.model.farmId
          );
          if (!existeFincaEnEmpresaNueva) {
            this.model.farmId = null;
          }
        }
      },
    },
  },*/

  methods: {
    /**
     * Close the form for creating an event
     */
    handleClose() {
      this.resetForm('form');
      this.showTable = false;
      this.rowIndex = -1;
      this.originalRowData = null;
    },

    /**
     * Verifies if a specific date is equal to or later than the current date.
     * Used to determine if a calendar activity can still be edited.
     *
     * @param {string|Date} targetDate - The activity date to evaluate.
     * @returns {boolean} Returns true if the date is today or in the future, false if it has passed or is null.
     */
    isEditableDate(targetDate) {
      if (!targetDate) return false;
      const today = moment().startOf('day');
      const evalDate = moment(targetDate).startOf('day');
      return evalDate.isSameOrAfter(today);
    },

    /**
     * Updates the visible answer text based on the selected option in the dropdown menu.
     * If no option is selected, it clears the answer value.
     *
     * @param {Object} row - Object representing the table row being modified.
     */
    updateAnswerText(row) {
      if (!row.selected_option_id) {
        row.answer = null;
        return;
      }

      let selectedOption = row.options.find(
        (opt) => opt.id === row.selected_option_id
      );

      if (selectedOption) {
        row.answer = selectedOption.name;
      } else {
        row.answer = null;
      }
    },

    /**
     * Activates the edit mode for a specific row.
     * Creates a backup of the original data to restore it in case the user decides to cancel the edit.
     *
     * @param {Object} row - The current row to edit.
     * @param {number} index - The index position of the row in the table.
     */
    startEditing(row, index) {
      this.originalRowData = {
        answer: row.answer,
        selected_option_id: row.selected_option_id,
      };
      this.rowIndex = index;
    },

    /**
     * Cancels the edit mode for a row and restores the values to their original state
     * using the backup created by startEditing().
     *
     * @param {Object} row - The table row whose edit is being cancelled.
     */
    cancelEditing(row) {
      if (this.originalRowData) {
        row.answer = this.originalRowData.answer;
        row.selected_option_id = this.originalRowData.selected_option_id;
      }
      this.rowIndex = -1;
      this.originalRowData = null;
    },

    /**
     * Saves the changes of an edited activity by sending the data to the backend via Axios.
     * Upon receiving a successful response, it updates the local table view, the metrics,
     * and refreshes the corresponding event in FullCalendar to keep data synchronized
     * without requiring a full page reload.
     *
     * @param {Object} row - The specific row containing the edited answer.
     * @param {Object} model - The parent event object containing global metrics, business, and audit IDs.
     * @param {number} rowIndex - The index of the row that has just been saved.
     */
    async saveRow(row, model, rowIndex) {
      if (this.isUpdate()) {
        this.showHideLoading(true);
        let data = {
          route: 'grow/activitylog/updateactivity',
          answer_id: row.answer_id,
          calification_type: row.calification_type,
          answer: row.answer,
          selected_option_id: row.selected_option_id,
          option_task_id: model.option_task_id,
          date: model.date,
          businessId: model.businessId,
          auditId: model.auditId,
          responsibleId: model.responsibleId,
        };
        Axios.postMasters(data)
          .then((response) => {
            const { listActivities, complianceMetrics } = response.data.data;
            this.tableData = [...listActivities];
            this.model = Object.assign({}, this.model, complianceMetrics);

            const eventIndex = this.calendarOptions.events.findIndex(
              (e) => e.id === this.model.id
            );
            if (eventIndex !== -1) {
              this.calendarOptions.events[eventIndex].listActivities =
                listActivities;
              this.calendarOptions.events[eventIndex].totalAssigned =
                complianceMetrics.totalAssigned;
              this.calendarOptions.events[eventIndex].totalCompleted =
                complianceMetrics.totalCompleted;
              this.calendarOptions.events[eventIndex].compliancePercentage =
                complianceMetrics.compliancePercentage;
            }

            this.rowIndex = -1;
            this.originalRowData = null;
            this.showNotification(
              response.data.message,
              'success',
              'nc-simple-add',
              'Exitoso...'
            );
          })
          .catch((error) => this.showMessageErrors(error))
          .finally(() => {
            this.showHideLoading();
          });
      } else {
        this.showMessageAccess();
      }
    },

    /**
     * Reset the variables in the event creation form
     *
     * @param {String} formName form name
     */
    resetForm(formName) {
      this.model.id = null;
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },

    /**
     * Initializes and configures the table layout and search settings.
     * Retrieves the predefined configuration from configTable() and assigns
     * the table columns and pagination properties to the component's state.
     */
    setupTable() {
      const { Table, Search } = configTable();
      this.Table = Table;
      this.Search = Search;
      this.tableColumns = Table.tableColumns;
      this.pagination = Table.pagination;
    },

    /**
     * Perform the query of events taking into account the filters of responsible parties, observers, purposes and areas
     *
     * @param {String} formName form name
     */
    consultData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.showHideLoading(true);
          let now = moment();
          let filter = {
            date: now.format('YYYY-MM-DD'),
            route: 'grow/activitylog/getlistevents',
            filters: this.filter,
          };
          Axios.postMasters(filter)
            .then((response) => {
              this.dialogVisibleFilters = false;
              this.listEvents = response.data.data.listEvents;
              this.calendarOptions.events = [];
              this.listEvents.forEach((event) => {
                this.addEvents(event);
              });
              let fullCalendar = this.$refs.fullCalendar.getApi();
              let date = now.format('YYYY-MM-DD');
              if (this.filter.year != now.format('YYYY'))
                date = this.listEvents[0].date;
              fullCalendar.gotoDate(date);
            })
            .catch((error) => {
              this.showMessageErrors(error);
            })
            .finally(() => {
              this.showHideLoading();
            });
        } else {
          return false;
        }
      });
    },

    /**
     * Remove log entry
     *
     */
    handleRemove() {
      if (this.isDelete()) {
        SweetAlert.delete(i18n.t('grow.activitylog')).then((result) => {
          if (result.value) {
            this.showHideLoading(true);
            let now = moment();
            let data = {
              date: now.format('YYYY-MM-DD'),
              route: 'grow/activitylog/delete',
              filters: this.filter,
              registered_audit_ID: this.model.registered_audit_ID,
            };
            Axios.postMasters(data)
              .then((response) => {
                this.calendarOptions.events = [];
                this.dialogVisibleFilters = false;
                this.dialogVisible = false;
                this.listEvents = response.data.data.listEvents;
                this.listEvents.forEach((event) => {
                  this.addEvents(event);
                });
                this.showNotification(
                  response.data.message,
                  'success',
                  'nc-simple-add',
                  'Exitoso...'
                );
              })
              .catch((error) => this.showMessageErrors(error))
              .finally(() => {
                this.showHideLoading();
              });
          }
        });
      } else {
        this.showMessageAccess();
      }
    },

    /**
     * Extracts and maps a single event's parameters to be rendered in the calendar view.
     *
     * @param {Object} param - The event data object.
     * @param {Number|null} param.id - Unique identifier of the event.
     * @param {Number|null} param.responsibleId - ID of the supervisor/responsible holding the event.
     * @param {String|null} param.email - Notification email associated with the event.
     * @param {Number|null} param.businessId - ID of the business/company.
     * @param {Number|null} param.farmId - ID of the specific farm.
     * @param {Number|null} param.areaId - ID of the specific area within the farm.
     * @param {Number|null} param.statusId - Current status ID (e.g., done, in progress, expired).
     * @param {String|null} param.date - Scheduled date of the event in 'YYYY-MM-DD' format.
     * @param {Object} param.complianceMetrics - Object containing compliance metrics (e.g., total assigned, completed tasks, and fulfillment percentage).
     * @param {Array} param.listActivities - Array containing the sub-activities for this event.
     */
    addEvents(param) {
      const {
        id,
        responsibleId,
        email,
        businessId,
        //farmId,
        areaId,
        statusId,
        date,
        complianceMetrics,
        listActivities,
        registered_audit_ID,
        auditId,
      } = param;
      const responsible =
        this.listUsers.find((r) => r.id === responsibleId) || '';
      const business =
        this.listBusinesses.find((b) => b.id === businessId) || '';
      //const farm = this.filteredFarms.find((f) => f.id === farmId) || '';
      const area = this.listAreas.find((a) => a.id === areaId) || '';
      const title = `
      <strong>${this.$i18n.t('grow.responsible')}:<br></strong> 
      ${responsible.first_name} ${responsible.last_name}<br>
      <strong>${this.$i18n.t('common_words.company')}:<br></strong> 
      ${business.name}<br>
       <strong>${this.$i18n.t('common_words.area')}:</strong> ${area.name}`;
      this.calendarOptions.events.push({
        id: id,
        responsibleId: responsibleId,
        businessId: businessId,
        email: email,
        //farmId: farmId,
        areaId: areaId,
        statusId: statusId,
        status:
          statusId == 1
            ? this.$i18n.t('common_words.scheduled')
            : statusId == 2
            ? this.$i18n.t('common_words.completed')
            : this.$i18n.t('common_words.expired'),
        registered_audit_ID: registered_audit_ID,
        auditId: auditId,
        title: title,
        date: date,
        totalAssigned: complianceMetrics.totalAssigned,
        totalCompleted: complianceMetrics.totalCompleted,
        compliancePercentage: complianceMetrics.compliancePercentage,
        listActivities: listActivities,
        allDay: false,
        backgroundColor:
          statusId == 1 ? '#ffc107' : statusId == 2 ? '#4f8949' : '#c63d2f', //#888888
        textColor: '#fff',
        display: 'block',
      });
    },

    /**
     * Displays the form for editing the event when we select an event from the calendar
     *
     * @param {Object} arg fullcalendar object
     */
    async handleEventClick(arg) {
      this.dialogVisible = true;
      const event = this.calendarOptions.events.find(
        (e) => e.id === arg.event.id * 1
      );
      const now = moment();
      const eventDateTime = moment(`${event.date}`);

      if (now.isBefore(eventDateTime)) {
        this.ShowEditButton = false;
      } else {
        this.ShowEditButton = true;
      }
      if (event.statusId == 2) {
        this.ShowEditButton = true;
      }
      const year = moment(event.date).year();
      this.model = {
        id: event.id,
        responsibleId: event.responsibleId,
        email: event.email,
        date: event.date,
        year: year,
        businessId: event.businessId,
        //farmId: event.farmId,
        areaId: event.areaId,
        statusId: event.statusId,
        status: event.status,
        totalAssigned: event.totalAssigned,
        totalCompleted: event.totalCompleted,
        compliancePercentage: event.compliancePercentage,
        listActivities: event.listActivities,
        registered_audit_ID: event.registered_audit_ID,
        auditId: event.auditId,
      };
      this.setupTable();
      if (event.listActivities) this.tableData = event.listActivities;
      else this.tableData = [];
      this.fuseSearch = new Fuse(this.tableData, {
        useExtendedSearch: true,
        threshold: 0.3,
        keys: this.tableColumns.map((column) => {
          return column.prop;
        }),
      });
    },
  },

  created() {
    this.showHideLoading(true);
    let now = moment();
    let data = {
      date: now.format('YYYY-MM-DD'),
      route: 'grow/activitylog/getselectinfo',
      filters: this.filter,
    };
    Axios.postMasters(data)
      .then((response) => {
        let res = response.data.data;
        this.listUsers = res.listUsers;
        this.listAreas = res.listAreas;
        this.listBusinesses = res.listBusinesses;
        //this.listFarms = res.listFarms;
        this.listEvents = res.listEvents;
        this.filter.responsibleIds = this.listUsers.map((item) => item.id);
        this.filter.businessesIds = this.listBusinesses.map((item) => item.id);
        /*this.filter.areaIds = this.listAreas.map((item) => item.id);
        this.$nextTick(() => {
          this.filter.farmIds = this.filteredFarms.map((item) => item.id);
        });*/
        this.listEvents.forEach((event) => {
          this.addEvents(event);
        });
      })
      .catch((error) => {
        this.showMessageErrors(error);
      })
      .finally(() => {
        this.showHideLoading();
      });
  },

  mounted() {
    this.selectedItemOnMenu('activitylog');
    this.calendarOptions.locale =
      localStorage.getItem('locale') == 'pt_BR'
        ? 'pt-br'
        : localStorage.getItem('locale');
    EventBus.$on('locale-changed', (newLocale) => {
      this.calendarOptions.locale = newLocale == 'pt_BR' ? 'pt-br' : newLocale;
      this.calendarOptions.customButtons.myFilterButton.text = this.$t(
        'common_words.filters'
      );
      this.calendarOptions.buttonText = {
        today: this.$t('common_words.today'),
        month: this.$t('common_words.month'),
        week: this.$t('common_words.week'),
        day: this.$t('common_words.day'),
        multiMonthYear: this.$t('common_words.year'),
      };
      this.calendarOptions.events = [];
      this.listEvents.forEach((event) => {
        this.addEvents(event);
      });
    });
  },

  beforeDestroy() {
    this.deselectedItemOnMenu('activitylog');
  },
};
</script>
<style scoped>
::v-deep .fc-event {
  white-space: normal !important;
  height: auto !important;
  cursor: pointer;
}

::v-deep .fc-event:hover {
  filter: brightness(1.1);
}

::v-deep .fc-event-title,
::v-deep .fc-event-title-container {
  white-space: normal !important;
  word-break: break-word;
}

::v-deep .fc-event {
  border-radius: 6px;
  font-size: 12px;
}

::v-deep .fc-event-main {
  padding: 4px 6px;
  line-height: 1.3;
}

::v-deep .fc-button {
  background-color: #4f8949 !important;
  border-color: #4f8949 !important;
  color: white !important;
  border-radius: 6px !important;
  font-size: 14px !important;
  padding: 8px 16px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.45) !important;
  opacity: 1 !important;
  filter: none !important;
}

::v-deep .fc-button:hover {
  background-color: #3d6b38 !important;
  border-color: #3d6b38 !important;
}

::v-deep .fc-button-active,
::v-deep .fc-button:focus {
  background-color: #2d5029 !important;
  border-color: #2d5029 !important;
  box-shadow: none !important;
}

::v-deep .el-tabs--left .el-tabs__item.is-left {
  text-align: left !important;
  font-weight: bold;
}

::v-deep .el-tabs--left .el-tabs__item.is-left:hover {
  color: #4f8949 !important;
}

::v-deep .el-tabs__item {
  color: #5e5e5e !important;
}

::v-deep .el-tabs__item.is-active {
  color: #6ba652 !important;
  opacity: 1 !important;
  background: #8bb35227 !important;
}

::v-deep .el-tabs__active-bar {
  background-color: #4f8949 !important;
}

::v-deep .el-collapse-item .el-collapse-item__header {
  color: #4f8949 !important;
  font-weight: bold;
}

::v-deep .el-collapse-item .el-collapse-item__header:hover {
  color: #6ba652 !important;
  opacity: 1 !important;
  background: #8bb35227 !important;
  font-weight: bold;
}
</style>
<style>
.el-picker-panel__content .el-year-table td.current a.cell {
  background-color: #4f8949 !important;
  color: #ffffff;
  border-radius: 50%;
}

.el-year-table td.today .cell {
  color: #6ba652;
  font-weight: 700;
}
</style>
